import { config } from "./config";
import Cookies from "js-cookie";
import { defaultServerConfig } from "./config/DefaultServerConfig";
const TOKEN_COOKIE = "Token";
const REFRESH_COOKIE = "Refresh-Token";
const USER_INITIALISATION_COOKIE = "User-Initialisation-Token";
const TOKEN_HEADER = TOKEN_COOKIE.toLowerCase();
const REFRESH_HEADER = REFRESH_COOKIE.toLowerCase();
const USER_INITIALISATION_HEADER = USER_INITIALISATION_COOKIE.toLowerCase();
export const tokens = (() => {
    const _config = config.get();
    let serverConfig = defaultServerConfig;
    //store locally for tests!
    let _tokenTimeout;
    let _token = "";
    let _refreshTokenTimeout;
    let _refreshToken = "";
    let _initialisationTokenTimeout;
    let _initialisationToken = "";
    function setTokens(token, refreshToken, initialisationToken) {
        if (typeof token === "object") {
            const headerToken = token[TOKEN_HEADER] || "";
            const headerRefreshToken = token[REFRESH_HEADER] || "";
            const headerInitialisationToken = token[USER_INITIALISATION_HEADER] || "";
            token = headerToken;
            refreshToken = headerRefreshToken;
            initialisationToken = headerInitialisationToken;
        }
        else {
            token = token ? token : "";
            refreshToken = refreshToken ? refreshToken : "";
            initialisationToken = initialisationToken ? initialisationToken : "";
        }
        let expireMilliseconds = 10, refreshExpireMilliseconds = 10, initialisationExpireMilliseconds = 10, expireDate = new Date(), refreshExpireDate = new Date(), initialisationExpireDate = new Date();
        if (token && refreshToken) {
            if (serverConfig.version === "===default===") {
                (async () => {
                    const fetchedConfig = await config.server(token);
                    if (fetchedConfig) {
                        serverConfig = fetchedConfig;
                    }
                })();
            }
            expireDate = new Date(Date.now() +
                (expireMilliseconds =
                    serverConfig.token_expiration_seconds_in_the_future_access * 1000));
            refreshExpireDate = new Date(Date.now() +
                (refreshExpireMilliseconds =
                    serverConfig.token_expiration_seconds_in_the_future_refresh * 1000));
            initialisationExpireDate = new Date(Date.now() +
                (initialisationExpireMilliseconds =
                    serverConfig.token_expiration_seconds_in_the_future_user_initialisation *
                        1000));
        }
        clearTimeout(_tokenTimeout);
        _tokenTimeout = setTimeout(() => {
            _token = "";
        }, expireMilliseconds);
        _token = token;
        clearTimeout(_refreshTokenTimeout);
        _refreshTokenTimeout = setTimeout(() => {
            _refreshToken = "";
        }, refreshExpireMilliseconds);
        _refreshToken = refreshToken;
        Cookies.set(REFRESH_COOKIE, refreshToken, {
            Secure: booleanToString(_config.secure),
            Expires: refreshExpireDate.toUTCString(),
            SameSite: "strict",
        });
        clearTimeout(_initialisationTokenTimeout);
        _initialisationTokenTimeout = setTimeout(() => {
            _initialisationToken = "";
        }, initialisationExpireMilliseconds);
        _initialisationToken = initialisationToken;
        Cookies.set(USER_INITIALISATION_COOKIE, initialisationToken, {
            Secure: booleanToString(_config.secure),
            Expires: initialisationExpireDate.toUTCString(),
            SameSite: "strict",
        });
        return getTokens();
    }
    function booleanToString(bool) {
        return bool ? "true" : "false";
    }
    function getTokens() {
        return {
            token: _token,
            refreshToken: Cookies.get(REFRESH_COOKIE) || _refreshToken,
            initialisationToken: Cookies.get(USER_INITIALISATION_COOKIE) || _initialisationToken,
        };
    }
    return {
        set: setTokens,
        get: getTokens,
    };
})();
